import React, { useState } from "react";
import PrimaryButton from "../../Components/Common/PrimaryButton";
import moment from "moment";
import { useHistory } from "react-router";
import "./linkRegister.css";
import AddIcon from "@mui/icons-material/Add";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import Button from "@mui/material/Button";
import Card from "@mui/material/Card";

import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import linkRegcss from "../../myfin_v2/css/linkReg.module.css";
import { Button } from "../../myfin_v2/elements/Button";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { ReactComponent as CalenderIcon } from "../../myfin_v2/assets/icons/calender.svg";
import MapRegModal from "./MapRegModal";
import CompanySVGComponent from "../../Components/Common/SVGComponents/CompanySVGComponent";

const LinkRegisterTable = ({
  keyElement,
  data,
  AddNewTableRow,
  handleDrop,
  HandleChange,
  HandleMapping,
  selRecRegCY,
  selRecRegPY,
  selPayRegCY,
  selPayRegPY,
  selLoanRegCY,
  selLoanRegPY,
  selLoanPrecedingYear,
  selLeaseRegCY,
  selLeaseRegPY,
  selFixedAssetsRegCY,
  selFixedAssetsRegPY,
  selSalesRegCY,
  selSalesRegPY,
  selPurchaseRegCY,
  selPurchaseRegPY,
}) => {
  const history = useHistory();
  const [mapRegModal, setMapRegModal] = useState(false);
  const [mapCategory, setMapCategory] = useState(null);

  return (
    <React.Fragment key={keyElement}>
      <div
        className="mt-3"
        style={{ border: "1px solid #ebebeb", "border-radius": "10px" }}
      >
        <p
          className={`header text-capitalize m-0 p-3 ${linkRegcss.header} ${commoncss.fw500}`}
        >
          {keyElement}
        </p>

        <table>
          <thead>
            {keyElement === "loans" && (
              <>
                <tr>
                  <th className="w-25 font-size-14 text-uppercase custom-font-600 border-top-0 border-bottom-0 lease-table font-sans text-secondary">
                    Current Year
                  </th>
                  <th className="w-25 font-size-14 text-uppercase custom-font-600 border-top-0 border-bottom-0 lease-table font-sans text-secondary">
                    Previous Year
                  </th>
                  <th className="w-25 font-size-14 text-uppercase custom-font-600 border-top-0 border-bottom-0 lease-table font-sans text-secondary">
                    Preceding Year
                  </th>
                  <th className="w-25  border-top-0 border-bottom-0 lease-table font-sans text-uppercase text-secondary"></th>
                </tr>
              </>
            )}
            {(keyElement === "lease" ||
              keyElement === "payable" ||
              keyElement === "receivable") && (
              <>
                <tr>
                  <th className="w-25 font-size-14 text-uppercase custom-font-600 border-top-0 border-bottom-0 lease-table font-sans text-secondary">
                    Current Year
                  </th>
                  <th className="w-25 font-size-14 text-uppercase custom-font-600 border-top-0 border-bottom-0 lease-table font-sans text-secondary">
                    Previous Year
                  </th>
                  <th className="w-25  border-top-0 border-bottom-0 lease-table font-sans text-uppercase text-secondary"></th>
                </tr>
              </>
            )}
          </thead>

          <tbody className=" text-left bg-white ">
            {keyElement === "lease" &&
              data[keyElement]?.length > 0 &&
              data[keyElement].map((dataEle, ix) => {
                const rowCYData = selLeaseRegCY[ix] || [];
                const rowPYData = selLeaseRegPY[ix] || [];

                return (
                  <tr key={ix}>
                    {/* ================= CY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "cy")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.cy) ? (
                        rowCYData.length > 0 ? (
                          rowCYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.cy} />
                      )}
                    </td>

                    {/* ================= PY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "py")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.py) ? (
                        rowPYData.length > 0 ? (
                          rowPYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.py} />
                      )}
                    </td>

                    {/* ================= MAP ================= */}
                    <td className="border-top-0 border-bottom-0">
                      {ix === 0 && (
                        <Button
                          btnColor={buttoncss.primary}
                          label="Map"
                          onClick={() => {
                            setMapCategory("lease");
                            setMapRegModal(true);
                          }}
                        />
                      )}
                    </td>
                  </tr>
                );
              })}

            {keyElement === "loans" &&
              data[keyElement]?.length > 0 &&
              data[keyElement].map((dataEle, ix) => {
                const rowCYData = selLoanRegCY[ix] || [];
                const rowPYData = selLoanRegPY[ix] || [];
                const rowPreceedingYData = selLoanPrecedingYear[ix] || [];

                return (
                  <tr key={ix}>
                    {/* ================= CY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "cy")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.cy) ? (
                        rowCYData.length > 0 ? (
                          rowCYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.cy} />
                      )}
                    </td>

                    {/* ================= PY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "py")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.py) ? (
                        rowPYData.length > 0 ? (
                          rowPYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.py} />
                      )}
                    </td>

                    {/* ================= Preceeding Year ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "py")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.py) ? (
                        rowPreceedingYData.length > 0 ? (
                          rowPreceedingYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.preceding_year} />
                      )}
                    </td>

                    {/* ================= MAP ================= */}
                    <td className="border-top-0 border-bottom-0">
                      {ix === 0 && (
                        <Button
                          btnColor={buttoncss.primary}
                          label="Map"
                          onClick={() => {
                            setMapCategory("loans");
                            setMapRegModal(true);
                          }}
                        />
                      )}
                    </td>
                  </tr>
                );
              })}

            {keyElement === "receivable" &&
              data[keyElement]?.length > 0 &&
              data[keyElement].map((dataEle, ix) => {
                const rowCYData = selRecRegCY[ix] || [];
                const rowPYData = selRecRegPY[ix] || [];

                return (
                  <tr key={ix}>
                    {/* ================= CY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "cy")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.cy) ? (
                        rowCYData.length > 0 ? (
                          rowCYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.cy} />
                      )}
                    </td>

                    {/* ================= PY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "py")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.py) ? (
                        rowPYData.length > 0 ? (
                          rowPYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.py} />
                      )}
                    </td>

                    {/* ================= MAP ================= */}
                    <td className="border-top-0 border-bottom-0">
                      {ix === 0 && (
                        <Button
                          btnColor={buttoncss.primary}
                          label="Map"
                          onClick={() => {
                            setMapCategory("receivable");
                            setMapRegModal(true);
                          }}
                        />
                      )}
                    </td>
                  </tr>
                );
              })}

            {keyElement === "payable" &&
              data[keyElement]?.length > 0 &&
              data[keyElement].map((dataEle, ix) => {
                const rowCYData = selPayRegCY[ix] || [];
                const rowPYData = selPayRegPY[ix] || [];

                return (
                  <tr key={ix}>
                    {/* ================= CY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "cy")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.cy) ? (
                        rowCYData.length > 0 ? (
                          rowCYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.cy} />
                      )}
                    </td>

                    {/* ================= PY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "py")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.py) ? (
                        rowPYData.length > 0 ? (
                          rowPYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.py} />
                      )}
                    </td>

                    {/* ================= MAP ================= */}
                    <td className="border-top-0 border-bottom-0">
                      {ix === 0 && (
                        <Button
                          btnColor={buttoncss.primary}
                          label="Map"
                          onClick={() => {
                            setMapCategory("payable");
                            setMapRegModal(true);
                          }}
                        />
                      )}
                    </td>
                  </tr>
                );
              })}

            {keyElement === "fixed assets" &&
              data[keyElement]?.length > 0 &&
              data[keyElement].map((dataEle, ix) => {
                const rowCYData = selFixedAssetsRegCY[ix] || [];
                const rowPYData = selFixedAssetsRegPY[ix] || [];

                return (
                  <tr key={ix}>
                    {/* ================= CY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "cy")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.cy) ? (
                        rowCYData.length > 0 ? (
                          rowCYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.cy} />
                      )}
                    </td>

                    {/* ================= PY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "py")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.py) ? (
                        rowPYData.length > 0 ? (
                          rowPYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.py} />
                      )}
                    </td>

                    {/* ================= MAP ================= */}
                    <td className="border-top-0 border-bottom-0">
                      {ix === 0 && (
                        <Button
                          btnColor={buttoncss.primary}
                          label="Map"
                          onClick={() => {
                            setMapCategory("fixed_assets");
                            setMapRegModal(true);
                          }}
                        />
                      )}
                    </td>
                  </tr>
                );
              })}

            {keyElement === "sales" &&
              data[keyElement]?.length > 0 &&
              data[keyElement].map((dataEle, ix) => {
                const rowCYData = selSalesRegCY[ix] || [];
                const rowPYData = selSalesRegPY[ix] || [];

                return (
                  <tr key={ix}>
                    {/* ================= CY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "cy")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.cy) ? (
                        rowCYData.length > 0 ? (
                          rowCYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.cy} />
                      )}
                    </td>

                    {/* ================= PY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "py")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.py) ? (
                        rowPYData.length > 0 ? (
                          rowPYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.py} />
                      )}
                    </td>

                    {/* ================= MAP ================= */}
                    <td className="border-top-0 border-bottom-0">
                      {ix === 0 && (
                        <Button
                          btnColor={buttoncss.primary}
                          label="Map"
                          onClick={() => {
                            setMapCategory("sales");
                            setMapRegModal(true);
                          }}
                        />
                      )}
                    </td>
                  </tr>
                );
              })}

            {keyElement === "purchase" &&
              data[keyElement]?.length > 0 &&
              data[keyElement].map((dataEle, ix) => {
                const rowCYData = selPurchaseRegCY[ix] || [];
                const rowPYData = selPurchaseRegPY[ix] || [];

                return (
                  <tr key={ix}>
                    {/* ================= CY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "cy")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.cy) ? (
                        rowCYData.length > 0 ? (
                          rowCYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.cy} />
                      )}
                    </td>

                    {/* ================= PY ================= */}
                    <td
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => handleDrop(e, keyElement, ix, "py")}
                      className="text-center p-1 px-3 font-size-14 border-top-0 border-bottom-0"
                    >
                      {Array.isArray(dataEle?.py) ? (
                        rowPYData.length > 0 ? (
                          rowPYData.map((ele, idx) => (
                            <div
                              key={ele?.data?._id || idx}
                              draggable
                              className={`d-flex mt-2 p-2 bg-white cursor-pointer radius-8px ${linkRegcss.importRegCard}`}
                            >
                              <div>
                                <p className="m-0 p-0 font-size-14 font-weight-bold text-left">
                                  {ele?.data?.name}
                                </p>

                                <p className="m-0 p-0 font-size-12 text-secondary d-flex align-items-center">
                                  <CompanySVGComponent
                                    color="#ABA9A9"
                                    width={11}
                                    height={15}
                                  />
                                  <span className="ml-1">
                                    {ele?.data?.companyData?.company_name}
                                  </span>

                                  <CalendarMonthIcon
                                    className="ml-1"
                                    style={{ height: "15px" }}
                                  />
                                  <span className="ml-1">
                                    {moment(ele?.data?.createdAt).format(
                                      "MMMM DD YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </div>
                          ))
                        ) : (
                          <DropPlaceholder linkRegcss={linkRegcss} />
                        )
                      ) : (
                        <DisabledDate value={dataEle?.py} />
                      )}
                    </td>

                    {/* ================= MAP ================= */}
                    <td className="border-top-0 border-bottom-0">
                      {ix === 0 && (
                        <Button
                          btnColor={buttoncss.primary}
                          label="Map"
                          onClick={() => {
                            setMapCategory("purchase");
                            setMapRegModal(true);
                          }}
                        />
                      )}
                    </td>
                  </tr>
                );
              })}

            <tr>
              <td
                className="pr-4 pl-3 pb-1 border-top-0 border-bottom-0"
                colSpan={keyElement === "loans" ? 3 : 2}
              >
                <p
                  className="text-secondary font-size-12 custom-font-500 font-inter cursor-pointer"
                  onClick={() => AddNewTableRow(keyElement)}
                >
                  + Add more items
                </p>
              </td>

              <td className="border-top-0 border-bottom-0"></td>
            </tr>
          </tbody>
        </table>
      </div>
      {mapRegModal && (
        <MapRegModal
          setMapRegModal={setMapRegModal}
          mapCategory={mapCategory}
          setMapCategory={setMapCategory}
          selRecRegCY={selRecRegCY}
          selRecRegPY={selRecRegPY}
          selPayRegCY={selPayRegCY}
          selPayRegPY={selPayRegPY}
          selLoanRegCY={selLoanRegCY}
          selLoanRegPY={selLoanRegPY}
          selLoanPrecedingYear={selLoanPrecedingYear}
          selLeaseRegCY={selLeaseRegCY}
          selLeaseRegPY={selLeaseRegPY}
          selFixedAssetsRegCY={selFixedAssetsRegCY}
          selFixedAssetsRegPY={selFixedAssetsRegPY}
          selSalesRegCY={selSalesRegCY}
          selSalesRegPY={selSalesRegPY}
          selPurchaseRegCY={selPurchaseRegCY}
          selPurchaseRegPY={selPurchaseRegPY}
        />
      )}
    </React.Fragment>
  );
};

const DropPlaceholder = ({ linkRegcss }) => (
  <div className="d-flex justify-content-center" style={{ height: "70px" }}>
    <div className="d-flex align-items-center dashed-border py-2 px-3 register-here">
      <span className={linkRegcss.dropLabel}>Drop your register here</span>
    </div>
  </div>
);

const DisabledDate = ({ value }) => (
  <InputGroup
    class_={commoncss.widthFC}
    inputs={[
      <>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
            <MobileDatePicker
              className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
              disabled
              value={dayjs(value)}
              sx={{
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
            />
          </DemoContainer>
        </LocalizationProvider>
        <span className="icon">
          <CalenderIcon className="vaMiddle" width={20} height={20} />
        </span>
      </>,
    ]}
  />
);

export default LinkRegisterTable;
